import renderMathInElement from 'katex/contrib/auto-render';

function typesetKatex(nodeRef = document.body) {
  const node = "current" in nodeRef ? nodeRef.current ?? document.body : nodeRef;
  renderMathInElement(node, {
    strict: "ignore",
    output: "htmlAndMathml",
    throwOnError: false
  });
}

export { typesetKatex };
//# sourceMappingURL=dom.typeset-katex.js.map
